import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { Header } from '@/components/Layout/Header';
import { Footer } from '@/components/Layout/Footer';
import Home from '@/pages/Home';
import Sobre from '@/pages/Sobre';
import Areas from '@/pages/Areas';
import Trabalhista from '@/pages/Trabalhista';
import PlanoSaude from '@/pages/PlanoSaude';
import BPCLOAS from '@/pages/BPCLOAS';
import BuscaApreensao from '@/pages/BuscaApreensao';
import Contato from '@/pages/Contato';
import Blog from '@/pages/Blog';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main className="pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/areas" element={<Areas />} />
            <Route path="/trabalhista" element={<Trabalhista />} />
            <Route path="/plano-saude" element={<PlanoSaude />} />
            <Route path="/bpc-loas" element={<BPCLOAS />} />
            <Route path="/busca-apreensao" element={<BuscaApreensao />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/blog" element={<Blog />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;